import styled from 'styled-components';

import { cssStyle as cssTertiaryButtonStyle } from '~/src/common/components/Button/Variants/PinkButton';
import { cssStyle as cssPrimaryButtonStyle } from '~/src/common/components/Button/Variants/PrimaryButton';
import { cssStyle as cssSecondaryButtonStyle } from '~/src/common/components/Button/Variants/SecondaryButton';

export const StyledLink = styled.a<{ variant: 'primary' | 'secondary' | 'tertiary' }>`
  ${({ variant }) =>
    variant === 'primary'
      ? cssPrimaryButtonStyle
      : variant === 'secondary'
      ? cssSecondaryButtonStyle
      : cssTertiaryButtonStyle}

  padding: 8px 24px;

  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  border-radius: ${({ theme }) => theme.layout.borderRadius};
  border: 1px solid
    ${({ theme, variant }) =>
      variant === 'tertiary' ? theme.palette.common.PITAYA : theme.palette.common.PRIMARY};
  box-shadow: none;
`;
